/**
 * Региональные проекты CAMP4ASB и CAHMP.
 * Страницы отличались только префиксом ключей перевода — свели к данным.
 */
export const REGIONAL_PROGRAMS = [
  {
    slug: "CAMP4ASB",
    path: "CAMP4ASB",
    titleKey: "camp4asb_title",
    sections: [
      { titleKey: "camp4asb_intro_title", textKey: "camp4asb_intro_text" },
      { titleKey: "camp4asb_goals_title", textKey: "camp4asb_goals_text" },
      {
        titleKey: "camp4asb_components_title",
        listKey: "camp4asb_components_list",
      },
    ],
  },
  {
    slug: "CAHMP",
    path: "CAHMP",
    titleKey: "cahmp_title",
    sections: [
      { titleKey: "cahmp_intro_title", textKey: "cahmp_intro_text" },
      { titleKey: "cahmp_goals_title", textKey: "cahmp_goals_text" },
      { titleKey: "cahmp_components_title", listKey: "cahmp_components_list" },
      { titleKey: "cahmp_funding_title", textKey: "cahmp_funding_text" },
    ],
  },
];

export const REGIONAL_PROGRAM_BY_SLUG = Object.fromEntries(
  REGIONAL_PROGRAMS.map((program) => [program.slug.toLowerCase(), program]),
);

export default REGIONAL_PROGRAMS;
